import { tablemill } from "../tablemill_metal";
import { ComparisonGraphForm } from "../view/comparison_graph_form";

class ComparisonController {
  private form: any;

  constructor() {
    tablemill.onController("comparisons", () => {
      this.form = new ComparisonGraphForm();
      this.form.initialize();
      this.form.render();
    });
  }
}

export { ComparisonController };
